export default __webpack_public_path__ + "static/media/JumpForce.3cf7b4bd.jpg";